import React from 'react';

export const BannerLoader = () => {
    const classes = [
        'asg-banners-loader',
        'display-flex',
    ];

    return (
        <div className={classes.join(' ')}>
            <div className="asg-banners-loader__icon" />
        </div>
    );
};
